import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CertificationsPanelComponent } from './certifications-panel.component';

@NgModule({
  declarations: [
    CertificationsPanelComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CertificationsPanelComponent
  ],
  providers: []
})
export class CertificationsPanelModule {}
